import { render, staticRenderFns } from "./AddIGGoods.vue?vue&type=template&id=4ac5728a&scoped=true&"
import script from "./AddIGGoods.vue?vue&type=script&lang=js&"
export * from "./AddIGGoods.vue?vue&type=script&lang=js&"
import style0 from "./AddIGGoods.vue?vue&type=style&index=0&id=4ac5728a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac5728a",
  null
  
)

export default component.exports